
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"4.667","height":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"ellipsis-vertical-solid","d":"M2.333 13.333A2.333 2.333 0 110 15.667a2.334 2.334 0 012.333-2.334zm0-6.667A2.333 2.333 0 110 9a2.334 2.334 0 012.333-2.333zm0-2a2.333 2.333 0 112.333-2.333 2.334 2.334 0 01-2.333 2.334z","fill":"#b6b7bb"}})])
          )
        }
      }
    